import { render, staticRenderFns } from "./RealVerify.vue?vue&type=template&id=0c169517&scoped=true&"
import script from "./RealVerify.vue?vue&type=script&lang=js&"
export * from "./RealVerify.vue?vue&type=script&lang=js&"
import style0 from "./RealVerify.vue?vue&type=style&index=0&id=0c169517&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c169517",
  null
  
)

component.options.__file = "RealVerify.vue"
export default component.exports